import type { CSSProperties } from 'react';
import CommandKeyIconSvg from '../../assets/icons/command_key.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const CommandKeyIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <CommandKeyIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default CommandKeyIcon;
